import classnames from 'classnames';
import { capitalize } from 'lodash';
import React, { useState, useEffect } from 'react';

import CqcLogo from '../../../assets/images/cqc-logo.inline.svg';
import { fetchData } from '../../../utils/fetch-data';
import * as styles from './CqcRating.module.scss';

const CqcRating = ({ cqcId }) => {
  const [ rating, setRating ] = useState('Loading');
  const theme = capitalize(rating?.replace(/ /g, ''));

  useEffect(() => {
    (async function getCqcData() {
      const { data } = await fetchData(`/.netlify/functions/get-cqc-status?id=${cqcId}`);
      setRating( data?.currentRatings?.overall?.rating || 'Pending');
    })();
  }, [ cqcId ]);

  return (
    <>
      <CqcLogo className={styles.logo} />

      <div className={styles.body}>
        <p>Overall rating:</p>

        <a
          className={classnames(styles.rating, {
            [ styles[ `theme${theme}` ] ]: !!rating,
          })}
          href={`https://www.cqc.org.uk/location/${cqcId}`}
          target="_blank"
          rel="noreferrer"
        >
          {rating}
        </a>
      </div>
    </>
  );
};

export default CqcRating;
